import { AdvancedVesselSortField } from "./advanced-vessel-search.models";

export const VESSEL_SEARCH_SORT_COLUMNS: { field: AdvancedVesselSortField; label: string }[] = [
  { field: "vesselName", label: "Vessel name" },
  { field: "cpDate", label: "CP date" },
  { field: "imo", label: "IMO number" },
  { field: "vesselType", label: "Vessel type" },
  { field: "owner", label: "Vessel owner" },
  { field: "dwt", label: "DWT" },
  { field: "safety", label: "Safety rating" },
  { field: "ghg", label: "GHG rating" },
];

export const VESSEL_SEARCH_TC_STATUSES = [
  "Delivered",
  "Fixed",
  "On Subjects",
  "Opportunity",
  "Redelivered",
  "Closed",
  "Withdrawn",
  "Canceled",
];

export const VESSEL_SEARCH_GHG_RATINGS = ["A", "B", "C", "D", "E", "F", "G"];
